import React from 'react';
import { Skeleton as AntSkeleton } from 'antd';

const Skeleton: React.FC = () => (
  <div className="admin-page skeleton">
    <AntSkeleton active paragraph={{ rows: 1, width: '100%' }} />
    <AntSkeleton active paragraph={{ rows: 1, width: '100%' }} />
    <AntSkeleton active paragraph={{ rows: 4, width: '100%' }} />
    <AntSkeleton active paragraph={{ rows: 4, width: '100%' }} />
  </div>
);

export default Skeleton;